import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { UseReload, UseSetEdit } from "#training/redux/actions"
import { UseReduxTraining } from "#training/redux/slice"
import { courseCollaboratorIdPut, courseCollaboratorPost } from "#training/services/Api"
import { Button, Stack } from "@mui/material"
import Box from "@mui/material/Box"
import { useCallback, useEffect, useMemo, useState } from "react"
import SelectCategory from "./SelectCategory"
import SelectCourse from "./SelectCourse"
import SelectMonth from "./SelectMonth"

const defaultValue = {
	// colaborador_id: "",
	category_id: "",
	curso_id: "",
	mes: "",
}
export default function FormCursoColaborador({ colaboradorId }) {
	const reloadNow = UseReload()
	const setEdit = UseSetEdit()
	const { edit } = UseReduxTraining()
	const [open, setOpen] = useState(false)
	const [disabled, setDisabled] = useState(false)
	const [data, setData] = useState({
		colaborador_id: colaboradorId,
		category_id: "",
		curso_id: "",
		mes: "",
	})

	const success = useCallback(() => {
		reloadNow()
		setOpen(false)
		setData((old) => ({ ...old, ...defaultValue }))
		setEdit(null)
	}, [reloadNow, setEdit])

	const request = useMemo(() => {
		if (edit) return courseCollaboratorIdPut
		return courseCollaboratorPost
	}, [edit])

	const { fetch, cancelar } = useApiSend(request, {
		success,
		end: () => setDisabled(false),
	})

	const handleClose = useCallback(() => {
		setOpen(false)
		setData((old) => ({ ...old, ...defaultValue }))
		if (typeof cancelar === "function") cancelar()
		setEdit(null)
	}, [cancelar, setEdit])

	useEffect(() => {
		if (edit) {
			setData({
				colaborador_id: edit?.colaborador_id,
				category_id: edit?.category_id,
				curso_id: "" || edit?.curso?.id,
				mes: edit?.mes,
			})
			setOpen(true)
		}

		setData((old) => ({
			...old,
			colaborador_id: colaboradorId,
		}))
	}, [colaboradorId, edit])

	const buttons = useMemo(
		() => [
			{ label: "Cancelar", onClick: cancelar },
			{
				label: edit ? "Editar" : "Crear",
				disabled,
				onClick: () => {
					setDisabled(true)
					edit ? fetch(edit?.id, data, { update: true }) : fetch(data)
				},
			},
		],
		[cancelar, data, disabled, edit, fetch]
	)

	return (
		<Box minWidth={"40%"} display={"flex"} justifyContent={"center"}>
			<Button onClick={() => setOpen(true)}>Crear Curso</Button>
			<MasterDialog
				{...{
					title: edit ? "Editar Curso" : "Crear Curso",
					open,
					setOpen,
					closeDialog: handleClose,
					buttons,
				}}
			>
				<Box>
					<Stack spacing={2} justifyContent={"center"} alignContent={"center"}>
						<SelectCategory
							value={data.category_id}
							setValue={(category_id) => setData({ ...data, category_id })}
							getData={(data) => {
								if (data.length === 1)
									setData((old) => ({ ...old, category_id: data[0]?.id }))
							}}
						/>
						<SelectMonth value={data.mes} setValue={(mes) => setData({ ...data, mes })} />
						<SelectCourse
							value={data.curso_id}
							setValue={(curso_id) => setData({ ...data, curso_id })}
						/>
					</Stack>
				</Box>
			</MasterDialog>
		</Box>
	)
}
